<template>
  <div class="contacts-tab">
    <ConfirmationDialog
      ref="confirmDialog"
      title="Confirm"
      confirm-label="Yes, delete contact"
      confirm-btn-type="danger"
      cancel-label="no, keep contact"
    />

    <ContactModal
      :main-address="mainAddress"
      :provider="provider"
      :contact="contactToEdit"
      :value="!!contactToEdit"
      @input="contactToEdit = null"
      @updated="getAndSetContacts(provider)"
    />

    <ContactModal
      v-model="newContactModal"
      :main-address="mainAddress"
      :provider="provider"
      @created="getAndSetContacts(provider)"
    />

    <Grid v-if="!contacts" place-items="center" class="full-height">
      <q-spinner color="primary" size="2.5em" />
    </Grid>

    <template v-else>
      <Grid class="cards-layout">
        <ContactCard
          v-for="contact in contacts"
          :key="contact.id"
          :contact="contact"
          @edit="onEdit(contact)"
          @delete="onDelete(contact)"
        />
        <NewContact @new-contact="newContactModal = true" />
      </Grid>
    </template>
  </div>
</template>

<script>
import * as apiTo from '@/modular-api'
// Libraries
import { cloneDeep } from 'lodash'
import { mapState, mapActions } from 'vuex'
// Components
import ConfirmationDialog from '@/ui/ConfirmationDialog'
import ContactModal from '@/reusable/contact-modal/ContactModal'
import NewContact from './components/NewContact'
import ContactCard from './components/contact-card/ContactCard'

export default {
  components: {
    ConfirmationDialog,
    NewContact,
    ContactModal,
    ContactCard
  },

  inject: ['mainAddress', 'provider'],

  data: () => ({
    contactToEdit: null,
    newContactModal: false
  }),

  computed: {
    ...mapState('provider-show', ['contacts'])
  },

  methods: {
    ...mapActions('provider-show', ['getAndSetContacts']),

    onEdit(contact) {
      this.contactToEdit = cloneDeep(contact)
    },

    onDelete(contact) {
      const dialog = this.$refs.confirmDialog.show({
        title: `Are you sure you want to delete ${contact.first_name} ${contact.last_name} as a contact?`,
        body: 'Are you sure you want to take this decision?'
      })
      dialog.onCancel(hide => hide())
      dialog.onConfirm(this.deleteContact.bind(this, contact.id))
    },

    deleteContact(id, hideModal, setModalLoading) {
      setModalLoading()

      apiTo
        .DELETE_CONTACT(id)
        .then(() => {
          hideModal()
          this.$store.commit(
            'provider-show/setContacts',
            this.contacts.filter(c => c.id !== id)
          )
        })
        .finally(() => setModalLoading(false))
    }
  }
}
</script>

<style lang="scss" scoped>
.contacts-tab {
  --card-width: 400px;
  --card-height: 545px;

  .cards-layout {
    height: 100%;
    grid-template-columns: repeat(auto-fill, minmax(var(--card-width, auto), 1fr));
    gap: var(--r-space-sp);
  }
}
</style>
